import React, {useEffect} from "react";
import {handleImgError} from "../../../static/js/Common2";
import {getImageList} from "../../../static/js/service/shopService";

export default function ShopImgV2({shopId}) {
  useEffect(() => {
    getImageList(shopId, 6).then((response) => {
      const filePath = response.length > 0 ? response[0].imageUrl : "";
      document.getElementById(`logo${shopId}`).setAttribute("src", filePath);
    });
  }, [shopId]);

  return (
    <img id={`logo${shopId}`} src="" alt="상점 로고" onError={(e) => handleImgError(e)} />
  )
}